import Vue from 'vue';
import Vuex from 'vuex';
import getters from './getters';
import app from './modules/app';
import settings from './modules/settings';
import user from './modules/user';
import tagsView from './modules/tagsView';
import menu from './modules/menu';
import msg from './modules/msg';
//import permission from './modules/permission'

Vue.use(Vuex);
var store = new Vuex.Store({
  modules: {
    app: app,
    settings: settings,
    user: user,
    tagsView: tagsView,
    menu: menu,
    msg: msg
  },
  getters: getters
});
export default store;